import React from 'react'
import Container from 'react-bootstrap/Container' 
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Sandytias from '../../assets/img/profile/sandytias.jpeg'
import Button from "react-bootstrap/Button";
import './About.css'

const About = () => {
    return (
        <div id='about'>
            <div className='about'>
            <h1 className='pt-3 text-center font-details pb-3'>ABOUT ME</h1>

            <Container>
            <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2 ">
                <Image className="profile justify-content-end" alt="profile" src={Sandytias} thumbnail fluid />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                  {/* description */}
                    Hi there! I am <strong>&nbsp;Sandy Tias Sasmita</strong>
                    <br/> I graduated from ISM (Indonesian School of Management) in Master's Degree at Economics. 
                    <br/><br/>Previously, I worked at PT Mandiri Utama Finance as a BRO (Business Relation Officer) for 5 months, and I decided to resign because I was interested in the world of IT, Web Development to be more precise. 
                    <br/><br/>To master my passion, I prepared myself by taking part in the Bootcamp at Purwadhika Startup and Coding School, and several other online courses.
                    <br/><br/>
                <Col className="d-flex justify-content-center flex-wrap">
                  <div>
                    <a href="#contact">
                      <Button className="m-2" variant="outline-primary">
                        Let's talk
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://res.cloudinary.com/dxenadjps/image/upload/v1639912296/images/CV_IT_doang_tzsvlu.jpg" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-success">
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://github.com/sandytias?tab=repositories" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-dark">
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.linkedin.com/in/sandy-sasmita-557618188/" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-info">
                        LinkedIn
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://res.cloudinary.com/dxenadjps/image/upload/v1629279606/images/Ijazah_S1_ugwlye.jpg" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-primary">
                        Ijazah S1
                      </Button>
                    </a>
                  </div><div>
                    <a href="https://res.cloudinary.com/dxenadjps/image/upload/v1629279646/images/Transkrip_S1_rvqkuk.jpg" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-dark">
                      Transkrip S1
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://res.cloudinary.com/dxenadjps/image/upload/v1629279672/images/Ijazah_S2_te1noi.jpg" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-primary">
                        Ijazah S2
                      </Button>
                    </a>
                  </div><div>
                    <a href="https://res.cloudinary.com/dxenadjps/image/upload/v1629279686/images/Transkrip_S2_jhkc0x.jpg" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-dark">
                      Transkrip S2
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
            </Container>
            </div>
        </div>
    )
}

export default About
